import { useScriptGoogleTagManager, useScriptClarity, useScript, defineNuxtPlugin } from '#imports'

export default defineNuxtPlugin({
  name: "scripts:init",
  env: { islands: false },
  parallel: true,
  setup() {
    const clarity = useScriptClarity({"id":"h2setu6orr"})
    const googleTagManager = useScriptGoogleTagManager({"id":"GTM-MFW896T"})
    return { provide: { $scripts: { clarity, googleTagManager } } }
  }
})